__turbopack_context__.v({
  "arrow": "Tooltip-module-scss-module__HRuctG__arrow",
  "bubble": "Tooltip-module-scss-module__HRuctG__bubble",
  "content": "Tooltip-module-scss-module__HRuctG__content",
  "iconButton": "Tooltip-module-scss-module__HRuctG__iconButton",
  "wrapper": "Tooltip-module-scss-module__HRuctG__wrapper",
});
